import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  CertificateSecStyle,
  CertificateLisContainer,
} from "./certificates.style";

import { FileViewer } from "../../components";

import { IMG_URL, getEndpoints } from "../../utils/Constants";

const Certificates = () => {
  const [certificates, setCertificates] = useState([]);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [certificatePath, setCertificatePath] = useState("");

  const fetchAllCertificates = async () => {
    try {
      const response = await axios.get(getEndpoints.getAllCertificates);
      if (response.data.status === "success") {
        setCertificates(response.data.data.docs);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    fetchAllCertificates();
  }, []);

  return (
    <CertificateSecStyle>
      <div className="certificate-header">
        <h1>Certificates</h1>
        <p>Some certificates to display are listed here.</p>
      </div>

      <CertificateLisContainer>
        {certificates?.map((certificate) => (
          <div
            onClick={() => {
              setIsViewOpen(true);
              setCertificatePath(certificate?.certificate_path);
            }}
            key={certificate._id}
          >
            <img
              src={IMG_URL + certificate.certificate_path}
              alt={certificate.title}
            />
          </div>
        ))}
      </CertificateLisContainer>

      {isViewOpen && (
        <FileViewer
          setIsViewOpen={setIsViewOpen}
          certificatePath={certificatePath}
        />
      )}
    </CertificateSecStyle>
  );
};

export default Certificates;
